import { render } from "./LockConsultModal.vue?vue&type=template&id=cd34b1e0&ts=true"
import script from "./LockConsultModal.vue?vue&type=script&lang=ts"
export * from "./LockConsultModal.vue?vue&type=script&lang=ts"

import exportComponent from "/buddy/uup/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__